import * as React from 'react';
import { ProtectedPageWrapper } from '../../designSystem/layouts/pageWrappers/ProtectedPageWrapper';
import { SingleColumnLayout } from '../../designSystem/layouts/SingleColumnLayout';
import { PageHeader } from '../../designSystem/PageHeader';

export function DummyPage(): JSX.Element 
{
    return (
        <ProtectedPageWrapper requiredPermissions={['SuperAdmin']}>
            <SingleColumnLayout
                noDivider
                contentContainer={
                    <>
                        <PageHeader 
                            headerIcon='survey_question'
                            headerText="Dummy" headerStyle="secondary-gray"
                        />

                        <span>{process.env.NODE_ENV}</span>
                    </>
                }
            />
        </ProtectedPageWrapper>
    );
}

